import { render, staticRenderFns } from "./AccountIconWh80.vue?vue&type=template&id=5beeb98e&"
import script from "./AccountIconWh80.vue?vue&type=script&lang=js&"
export * from "./AccountIconWh80.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports